export default {
    nav: {
        home: "首页",
        block: "区块链",
        viewblock: "查看区块",
        viewtx: "查看交易",
        token: "代币",
        rank: "持币排行",
        node: "节点",
        tool: "工具",
        analysis: "解析交易",
        broadcast: "广播交易",
    },
    footer: {
        txt: "区块链浏览器是一个提供区块数据查询与分析的平台。",
        linkTitle: "友情链接",
        bty: "比特元官网",
        wallet: "币钱包",
    },
    page: {
        first: "首页",
        last: "尾页",
        confirm: "确定",
        nodata: "暂无数据",
    },
    components: {
        hour: "小时",
        hours: "小时",
        min: "分",
        mins: "分",
        sec: "秒前",
        secs: "秒前",
        copy: "复制",
        tip: "提示",
        noMsg: "未查询到交易信息",
        repeat: "重试",
        copySuc: "复制成功",
        copyErr: "复制失败",
        allBlock: "全部区块",
        blockDetail: "区块详情",
        succ: "成功",
        fail: "失败",
        errMsg: "输入信息有误，请重新输入",
        errAdr: "地址错误",
        errParam: "传入参数有误!",
        errToken: "没有此Token!",
        errRequest: "数据请求失败!",
        errTxt: "交易文本不能为空!",
        errHeight: "输入的区块高度不能超过当前最大高度",
        errFormat: "格式错误，请填写交易的十六进制格式文本!",
        footer: "是一个提供区块数据查询与分析的平台。",
    },
    home: {
        title: "比特元区块链浏览器",
        banner: "比特元浏览器",
        keyword: "请输入地址/交易哈希/区块高度/DNS",
        search: "搜索",
        blockTitle: "最新区块",
        txCount: "交易笔数",
        time: "时间",
        txTitle: "最新交易",
        txHash: "交易哈希",
        sender: "发送方",
        receiver: "接收方",
        txValue: "交易金额",
        viewAll: "查看全部",
        mineRevenue: "挖矿收益",
        miner: "矿工",
        minerAdr: "矿工地址",
        fund: "发展基金",
        txs: "笔交易",
        tx: "笔交易",
        bi: "笔",
        nPrice: "当前价格",
        nNum: "当前总量",
        nMValue: "当前总市值",
        avgspeed: "平均出块时间",
        perTxns: "每秒交易数",
        burnQuotes: "燃烧行情",
        priceQuotes: "价格行情",
        burnCount: "燃烧总量",
    },
    block: {
        title: "全部区块",
        count: "个区块",
        height: "高度",
        time: "块龄",
        hash: "区块哈希",
        txCount: "交易数量",
        blockRevenue: "区块收益",
    },
    blockDetail: {
        title: "区块高度",
        general: "概况",
        last: "上个区块",
        next: "下个区块",
        mock: "默克尔根",
        statusHash: "状态哈希",
        record: "交易记录",
        nodata: "无",
    },
    trade: {
        title: "全部交易",
        count: "条交易",
        totalTip: "全部",
        tip: "显示最近10万条",
        hash: "交易哈希",
        sender: "发送方",
        receiver: "接收方",
        num: "数量",
        fee: "手续费",
        func: "调用函数",
        time: "时间",
        token: "代币",
    },
    txDetail: {
        title: "交易详情",
        status: "接收状态",
        success: "写入成功，执行成功",
        faild: "写入成功，执行失败",
        value: "价值",
        random: "随机数",
        execer: "执行器",
        txType: "交易类型",
        normalTx: "普通交易",
        groupTx: "交易组",
        inData: "输入数据",
        outData: "输出数据",
    },
    address: {
        contract:'合约地址',
        nav: "个人地址",
        title: "地址",
        tag: "标签",
        dns: "去绑定",
        save: "保存二维码",
        balance: "余额",
        placeholder: "请选择合约",
        frozen: "冻结",
        txCount: "交易笔数",
        treceive: "总接收",
        tsent: "总发送",
        total: "代币持仓",
        about: "约",
        tokenPlaceholder: "请输入代币名称或合约地址",
        record: "交易记录",
        tokenRecord: "代币交易记录",
        txTotal: "共找到{0}笔交易",
        last: "显示最近{0}条",
        allTx: "全部交易",
        succTx: "查看成功的交易",
        failTx: "查看失败的交易",
        sendTx: "查看发出的交易",
        receTx: "查看接收的交易",
    },
    token: {
        title: "代币",
        mainToken: "主代币",
        holder: "持有人",
        time: "时间",
        introduce: "币种介绍",
        tokenList: "代币列表",
        keyword: "请输入币种名称",
        total: "总共{0}种token代币",
        id: "编号",
        btyIntroduce:`      比特元，一种简单稳定、扩展性强的区块链网络。 国内第一个提出平行链，国内第一个区块链发明专利：钱包找回功能。 
      结合比特币、比特股、以太坊技术进行创新，秉承着简单稳定的原则，从而实现安全快速支付、隐私交易和原子互换、一键Token等功能，同时运用离线钱包和钱包找回等功能来保障比特元数字资产的安全性。
      比特元平行链有独立钱包、自我区块链生态等，而安全共识则由主链提供，提升整体生态的多样性。`
    },
    tokenDetail: {
        title: "代币详情",
        issueTotal: "发行总量",
        holder: "持有人",
        issueTime: "发行时间",
        point: "小数点",
        value: "价值",
        screen: "按代币持有者筛选",
        viewChart: "查看图表",
    },
    node: {
        title: "全球BTY节点情况",
        tip: "地图显示了世界各个国家及地区可到达BTY节点的集中度",
        count: "共{0}个节点",
        time: "截至北京时间{0}",
    },
    rank: {
        title: "持有者",
        holderNum: "持有量",
        range: "范围",
        best: "最佳",
        type: "类型",
        token: "代币",
        holderRank: "持币排行",
        mineRank: "挖矿排行",
        topHolder: "最佳{0}持有人总拥有约 {1} 的{2}",
        totalTip: "代币总供应量",
        holderTip: "总共代币持有人",
        ps: "注：最佳{0}账户所持有的总共 {1} 代币是来自 {2} 代币的总供应量",
        rank: "排名",
        adr: "地址",
        num: "数量",
        percent: "占比",
        contractAdr: "合约地址",
    },
    analysis: {
        title: "解析交易",
        tip:
            "您可以在此页面输入未签名的源交易，十六进制格式文本，将会解析成可读的格式。",
    },
    broadcast: {
        title: "广播交易",
        tip:
            "您可以在此页面输入已签名的源交易，十六进制格式文本，将会解析成可读的格式。",
        ps: "建议在广播交易之前，检查您的交易文本。",
        notice: "提示：",
        link: "去解析交易。",
        btn: "发送交易",
    },
};
